module.exports = __webpack_public_path__ + "static/media/ts8tj658.22837980.png";